
import {
getStoneRangeByCom,
getGoldstoneByFactory,
getCommodityDetail,
getGoldstone,
getStoneRange,
putAddMadeInlaidCart,
getCommodityMaterial,
putAddMadeGoldCart,
getMadeGoldAmount,
getMadeInlaidAmount,
getCategories,
GetCommodityDetailForMatch,
PutAddBatchMatchCart,
} from "./../../service/index";
import ZSelect from "@/components/Select";
import { zdsCategory } from "./../../config/env";
import { isNullOrEmpty } from "./../../util/util";
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'

const ZJD = require("./../../config/ZJD.json");
const ZColor = require("./../../config/ZColor.json");
const KSStart = ["A0A", "A0B", "A0C"];
export default {
data() {
return {
KSStart: KSStart,
currCategory: "",
zdsCategory: zdsCategory,
ZSQ: { Item: {}, List: [], Golds: [] },
ZSJ: { Item: {}, List: [], Golds: [] },
ZJD: ZJD,
ZColor: ZColor,
isZJQ: true,
IsChangeStyle: false,
CategoryList: [{ oid: "", name: "" }],
isShowZS: false,

ZSZ: [], //主石重
ZQ: [], //指圈/规格
showZSZ: false,
map_ZS: [
{ oid: "", name: "" },
{ oid: "有", name: "有" },
{ oid: "无", name: "无" },
],
};
},
components: {
ZSelect,
Group,
Cell,
XSwitch,
PopupHeader,
Popup,
TransferDom,
Radio,
},
computed: {
dataList() {
switch (this.currCategory) {
case zdsCategory.ZSQ:
return this.ZSQ.List;
case zdsCategory.ZSJ:
return this.ZSJ.List;
}
},
},
created() {
this.getCategories();

this.ZQ = [
{
oid: "不限",
name: "不限",
},
];
for (let i = 11; i <= 23; i++) {
this.ZQ.push({
oid: i,
name: i,
});
}
},
mounted() {
this.GetDetail();
},
watch: {
$route: function (to, from) {},
},
methods: {
StandardGold(obj) {
obj.StandardGold = (Number(obj.ZQSJZ) + Number(obj.ZJZJZ)) / 2;
},

onResultChange(val) {

let vm = this;
if (vm.currCategory === vm.zdsCategory.ZSQ) {
if (val.target === 0) {

this.ZSQ.List[val.id].MaterialCode = val.idx;
} else if (val.target === "PL") {

this.ZSQ.List[val.id].ZPLBM = val.idx;
if (val.idx === "01" || val.idx === "02" || val.idx === "03") {
this.isZJQ = true;
} else {
this.isZJQ = false;
}
} else if (val.target === "ZSZ") {


let ls = vm.ZSZ.filter((c) => c.oid === val.idx);
vm.ZSQ.List[val.id].ZZSZL = ls[0].name;
vm.getGoldstoneByFactory(val.idx, (res) => {

this.ZSQ.List[val.id].Golds = res.map((item, index) => ({
oid: item.ZJSBM,
name: item.ZJSMC,
}));
});
} else if (val.target === "ZQ") {



vm.ZSQ.List[val.id].ZZJQH = val.idx;
} else if (val.target === "JD") {
vm.ZSQ.List[val.id].ZJD = val.idx;
} else if (val.target === "SD") {
vm.ZSQ.List[val.id].ZSD = val.idx;
} else if (val.target === "ZS") {
vm.ZSQ.List[val.id].ZZS = val.idx;
}
} else if (vm.currCategory === vm.zdsCategory.ZSJ) {
if (val.target === 0) {
this.ZSJ.List[val.id].MaterialCode = val.idx;
} else if (val.target === "PL") {
this.ZSJ.List[val.id].ZPLBM = val.idx;
if (val.idx === "01" || val.idx === "02" || val.idx === "03") {
this.isZJQ = true;
} else {
this.isZJQ = false;
}
}
}
},
del(idx) {
let vm = this;
if (vm.currCategory === vm.zdsCategory.ZSQ) {
vm.ZSQ.List.splice(idx, 1);
} else if (vm.currCategory === vm.zdsCategory.ZSJ) {
vm.ZSJ.List.splice(idx, 1);
}
},
add() {
let vm = this;
if (vm.currCategory === vm.zdsCategory.ZSQ) {
vm.ZSQ.List.push({
CommodityOid: vm.ZSQ.Item.Oid,
MaterialCode: "",
ZZJQH: "不限",
FactoryOid: "",
ZJD: "",
ZSD: "",
ZZS: "",
Number: vm.ZSQ.Item.Number,
Name: vm.ZSQ.Item.Name,
Price: vm.ZSQ.Item.Price,
Amount: 0,
Unit: vm.ZSQ.Item.Unit,
ZZSZL: 0,
Qty: 1,
ZPMC: vm.ZSQ.Item.ZPMC,
ZPM: vm.ZSQ.Item.ZPM,
ZPLBM: vm.ZSQ.Item.ZPM,
StoneRanges: vm.ZSQ.Item.StoneRanges,
Golds: [],
Note: "",
IsChangeStyle: vm.ZSQ.Item.IsChangeStyle,
ReferencePrice: vm.ZSQ.Item.ReferencePrice,
TargetPrice: null,
});
} else if (vm.currCategory === vm.zdsCategory.ZSJ) {
vm.ZSJ.List.push({
Oid: vm.ZSJ.Item.Oid,
Number: vm.ZSJ.Item.Number,
Name: vm.ZSJ.Item.Name,
MaterialCode: "",
Price: vm.ZSJ.Item.Price,
Amount: 0,
Unit: vm.ZSJ.Item.Unit,
Specifications: vm.ZSJ.Item.Specifications,
StandardGold: vm.ZSJ.Item.StandardGold,
ZQSJZ: vm.ZSJ.Item.ZQSJZ,
ZJZJZ: vm.ZSJ.Item.ZJZJZ,
ZPMC: vm.ZSJ.Item.ZPMC,
ZPLBM: vm.ZSJ.Item.ZPM,
ZSJCZ: vm.ZSJ.Item.ZSJCZ, //材质字段选择改为展示
Qty: null,
Note: "",
ZZJQH: null,
IsChangeStyle: vm.ZSJ.Item.IsChangeStyle,
ReferencePrice: vm.ZSJ.Item.ReferencePrice, //全国统一标价
ProcessingFee: vm.ZSJ.Item.ProcessingFee, //工费
ZSJGY: vm.ZSJ.Item.ZSJGY, //工艺
});
}
setTimeout(() => {
document.documentElement.scrollTop = document.body.scrollTop =
document.body.scrollHeight - 100;
}, 100);
},
GetDetail() {
let vm = this;
let params = vm.$route.params;
vm.currCategory = params.type;

let pData = {
commodityOid: vm.$route.params.id,
bannerOId: vm.$route.query.bannerOId, //专区id
};
GetCommodityDetailForMatch(pData, (result) => {

console.log(JSON.parse(result.data));
if (result.code === "1") {
let data = JSON.parse(result.data);

if (vm.currCategory === vm.zdsCategory.ZSQ) {
vm.ZSQ.Item = {
Oid: data.OId,
Number: data.Number,
Name: data.Name,
Price: data.Price,
Unit: data.Unit,
ZPMC: data.ZPMC,
ZPM: data.ZPM,
IsChangeStyle: false,
ReferencePrice: data.ReferencePrice,
};

vm.IsChangeStyle = data.IsChangeStyle;
vm.doZJQ();
vm.getStoneRangeByCom(() => {
vm.add();
});
}

else if (vm.currCategory === vm.zdsCategory.ZSJ) {
/*
字段名	字段类型	含义
ZQSJZ	number	最小金重                    √
ZJZJZ	number	最大金重                    √
ZPJJZ	string	平均金重                    ？？什么用
ReferencePrice	string	全国统一价         √
ProcessingFee	string	工费                ？？怎么用
ZSJGY	string	工艺                        ？？怎么用
ZSJCL	string	                            ？？怎么用
ZSJCZ     "材质 材料"
*/

vm.ZSJ.Item = {
Oid: data.OId,
Number: data.Number,
Name: data.Name,
Price: data.Price,
Unit: data.Unit,
Specifications: data.Specifications,
StandardGold: (data.ZQSJZ + data.ZJZJZ) / 2,
ZQSJZ: data.ZQSJZ,
ZJZJZ: data.ZJZJZ,
ZPMC: data.ZPMC,
ZPM: data.ZPM,
ZSJCZ: data.ZSJCZ, //材质字段选择改为展示
IsChangeStyle: false,
ReferencePrice: data.ReferencePrice, //全国统一价
ProcessingFee: data.ProcessingFee, //工费
ZSJGY: data.ZSJGY, //工艺
};
vm.IsChangeStyle = data.IsChangeStyle;
vm.getCommodityMaterial();
vm.add();
}
}
});
},

getStoneRangeByCom(call) {
let vm = this;
getStoneRangeByCom(vm.$route.params.id, (result) => {
console.log(JSON.parse(result.data));
if (result.code === "1") {
if (vm.currCategory === vm.zdsCategory.ZSQ) {
let ls = JSON.parse(result.data);
if (ls.length > 0) {
vm.ZSQ.Item.StoneRanges = ls;
console.log("lalaal", ls);
vm.ZSZ = ls.map((item, index) => ({
key: item.OId,
value: item.ZZSQSZ + "-" + item.ZZSJZZ,
}));
} else {
vm.ZSQ.Item.StoneRanges = [];
}
}
}
call();
});
},
getGoldstoneByFactory(id, call) {
getGoldstoneByFactory(id, (result) => {
if (result.code === "1") {
call(JSON.parse(result.data));
} else {
call([]);
}
});
},
getGoldstone() {
let vm = this;
getGoldstone(vm.$route.params.id, (result) => {
if (result.code === "1") {
if (vm.currCategory === vm.zdsCategory.ZSQ) {
let ls = JSON.parse(result.data);
if (ls.length > 0) {
vm.ZSQ.Golds = ls.map((item, index) => ({
oid: item.ZJSBM,
name: item.ZJSMC,
}));



}
}
}
});
},
getCommodityMaterial() {
let vm = this;
getCommodityMaterial((result) => {
if (result.code === "1") {
let ls = JSON.parse(result.data);
if (ls.length > 0) {
vm.ZSJ.Golds = ls.map((item, index) => ({
oid: item.ZJSBM,
name: item.ZJSMC,
}));
}
}
});
},
GetStoneRange(id, call) {
let vm = this;
getStoneRange(vm.$route.params.id, id, (result) => {
if (result.code === "1") {
call(JSON.parse(result.data));
} else {
call([]);
}
});
},
getMadeInlaidAmount(idx) {
let vm = this;
let obj = vm.ZSQ.List[idx];
let pData = {
CommodityOid: obj.Oid,
MaterialCode: obj.MaterialCode,
ZZJQH: obj.ZZJQH,
ZZSZL: obj.ZZSZL,
FactoryOid: obj.FactoryOid,
ZJD: obj.ZJD,
ZSD: obj.ZSD,
Qty: obj.Qty,
};
if (!isNullOrEmpty(pData.MaterialCode)) {
vm.showToast("请选择材料名称");
return;
}
if (!isNullOrEmpty(pData.MaterialCode)) {
vm.showToast("请填写指圈");
return;
}
if (!isNullOrEmpty(pData.MaterialCode)) {
vm.showToast("请填写主石重");
return;
}
if (pData.Qty <= 0) {
vm.showToast("请填写数量");
return;
}
getMadeInlaidAmount(pData, (result) => {
if (result.code === "1") {
let data = JSON.parse(result.data);
obj.Price = data.Prcie;
obj.Amount = data.Amount;
}
});
},
getMadeGoldAmount(idx) {
let vm = this;
let obj = vm.ZSJ.List[idx];
let pData = {
CommodityOid: obj.Oid,
MaterialCode: obj.MaterialCode,
MinGold: obj.ZQSJZ,
MaxGold: obj.ZJZJZ,
StandardGold: obj.StandardGold,
Qty: obj.Qty,
Size: obj.Size,
};
if (!isNullOrEmpty(pData.MaterialCode)) {
vm.showToast("请选择材料名称");
return;
}
if (pData.MinGold < 0) {
vm.showToast("请填写最小金重");
return;
}
if (pData.MaxGold <= 0) {
vm.showToast("请填写最大金重");
return;
}
if (pData.Qty <= 0) {
vm.showToast("请填写数量");
return;
}
getMadeGoldAmount(pData, (result) => {
if (result.code === "1") {
let data = JSON.parse(result.data);
obj.Price = data.Prcie;
obj.Amount = data.Amount;
}
});
},
putAddMadeInlaidCart() {
let vm = this;
let params = vm.$route.params;
let postData = {
CommodityOid: params.id,
InlaidDetail: vm.ZSQ.List,
};

if (postData.InlaidDetail.filter((c) => c.ZPLBM === "").length > 0) {
vm.showToast("品类不能为空");
return;
}
if (
postData.InlaidDetail.filter(
(c) =>
(c.ZPLBM === "01" && c.ZZJQH === "") ||
(c.ZPLBM === "02" && c.ZZJQH === "") ||
(c.ZPLBM === "03" && c.ZZJQH === "") ||
(c.ZPLBM === "04" && c.ZZJQH === "") ||
(c.ZPLBM === "35" && c.ZZJQH === "")
).length > 0
) {
vm.showToast("指圈规格不能为空");
return;
}
if (vm.ZSQ.List.filter((c) => c.Amount <= 0).length > 0) {
vm.showToast("请填写完整的信息");
return;
} else {
putAddMadeInlaidCart(postData, (result) => {
if (result.code === "1") {
vm.showAlert("提交成功！", () => {
history.go(-1);
});
}
});
}
},
calculateDaysBetweenDates(begin, end) {},
putAddMadeGoldCart() {
let vm = this;
let params = vm.$route.params;
let postData = {
CommodityOid: params.id,
MatchDetail: vm.ZSJ.List.map((item, index) => ({
CommodityOid: params.id,




MinGold: item.ZQSJZ, //最小金重
MaxGold: item.ZJZJZ, //最大金重
ZPLBM: item.ZPLBM, //品类

IsChangeStyle: item.IsChangeStyle, //支持改款？保留？

ZZJQH: item.ZZJQH, //ZZJQH 指圈/规格？！
MBJZ: item.MBJZ, //目标金重
Qty: item.Qty, //数量
Note: item.Note, //备注
})),
};








/**
* 素金 需要前端传给后端的参数 只有
* 指圈/规格、ZZJQH
* 目标金重、MBJZ
* 数量、Qty
* 备注，Note
* 除了目标金重，其他字段名没有变化
*
*/

if (
postData.MatchDetail.filter(
(c) =>
["01", "02", "03", "04", "05"].indexOf(c.ZPLBM) != -1 && !c.ZZJQH
).length > 0
) {
vm.showToast("指圈规格不能为空");
return;
}
if (postData.MatchDetail.filter((c) => !c.MBJZ).length > 0) {
vm.showToast("目标金重不能为空");
return;
}
if (
postData.MatchDetail.filter((c) => Number(c.MBJZ) < Number(c.MinGold))
.length > 0
) {
vm.showToast("目标金重不能小于最小金重");
return;
}
if (
postData.MatchDetail.filter((c) => Number(c.MBJZ) > Number(c.MaxGold))
.length > 0
) {
vm.showToast("目标金重不能大于最大金重");
return;
}
if (postData.MatchDetail.filter((c) => !c.Qty).length > 0) {
vm.showToast("件数不能为空");
return;
}
console.log(JSON.stringify(postData));

PutAddBatchMatchCart(postData, (result) => {
if (result.code === "1") {
vm.showAlert("提交成功！", () => {
history.go(-1);
});
}
});
},

PutAddBatchMatchCart() {
let vm = this;
let params = vm.$route.params;
let postData = {
CommodityOid: params.id,
MatchDetail: vm.ZSQ.List,
};

if (postData.MatchDetail.filter((c) => c.ZPLBM === "").length > 0) {
vm.showToast("品类不能为空");
return;
}
if (
postData.MatchDetail.filter(
(c) =>
(c.ZPLBM === "01" && c.ZZJQH === "") ||
(c.ZPLBM === "02" && c.ZZJQH === "") ||
(c.ZPLBM === "03" && c.ZZJQH === "") ||
(c.ZPLBM === "04" && c.ZZJQH === "") ||
(c.ZPLBM === "35" && c.ZZJQH === "")
).length > 0
) {
vm.showToast("指圈规格不能为空");
return;
}
PutAddBatchMatchCart(postData, (result) => {
if (result.code === "1") {
vm.showAlert("提交成功！", () => {
history.go(-1);
});
}
});
},
putCart() {
let vm = this;
if (vm.currCategory === vm.zdsCategory.ZSQ) {
vm.PutAddBatchMatchCart(); 
} else if (vm.currCategory === vm.zdsCategory.ZSJ) {
vm.putAddMadeGoldCart(); 



}
},
checkZSL(idx) {
let vm = this;
let obj = vm.ZSQ.List[idx];
obj.ZZSZL = Number(obj.ZZSZL);

let ls = obj.StoneRanges.filter(
(c) => c.ZZSQSZ <= Number(obj.ZZSZL) && c.ZZSJZZ >= Number(obj.ZZSZL)
);
if (!(ls && ls.length > 0)) {
obj.ZZSZL = 0;




vm.showToast("不在主石重范围,请重新填写");
this.ZSQ.List[idx].Golds = [];
} else {
obj.FactoryOid = ls[0].OId;
vm.getGoldstoneByFactory(obj.FactoryOid, (res) => {
this.ZSQ.List[idx].Golds = res.map((item, index) => ({
oid: item.ZJSBM,
name: item.ZJSMC,
}));
});
}
},
checkZJQ(idx) {
console.log(idx);
this.isShowZS = true;
this.idx = idx;
















},
Qanhao(e) {
console.log(e);
console.log(e.target.innerText);
console.log(e.target.innerText.indexOf("："));

if (e.target.innerText.indexOf("：") === -1) {
this.ZSQ.List[this.idx].ZZJQH = e.target.innerText;
this.isShowZS = false;
}
},
doZJQ() {
let ls = KSStart.filter(
(c) => c.indexOf(this.ZSQ.Item.Number.substring(0, 3)) > -1
);
this.isZJQ = ls.length > 0;
},
getCategories() {
let vm = this;
getCategories(null, (result) => {
if (result.code === "1") {
console.log(JSON.parse(result.data));
let ls = JSON.parse(result.data);
for (let item of ls) {
vm.CategoryList.push({
oid: item.CategoryNumber,
name: item.CategoryName,
});
}
}
});
},
},
};



// WEBPACK FOOTER //
// ./src/page/product/matchsdetail.vue